<template>
    <f7-page id="account-input-password" name="account-input-password" @page:afterin="afterin">
        <f7-navbar class="view-mobile">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <div class="block">
            <div class="fw-bold fs-24 mb-md">{{ $t('ua-enter-password') }}</div>
            <f7-list form class="form-group" @submit="submitForm">
                <f7-list-input
                    input-id      ="password"
                    name          ="password"
                    :type         ="passwordInputType"
                    class         =""
                    :label        ="$t('general-text-password')"
                    :placeholder  ="$t('placeholder-password')"
                    @input        ="password = $event.target.value; validateInput($event.target)"
                    autocomplete  ="off"
                    outline
                    floating-label
                    required
                    validate
                >
                    <div class="toggle-password" @click="showHidePassword" id="password-icon" toggle="#password-field" slot="content-end" style="">
                        <i class="f7-icons">eye_slash</i>
                    </div>
                </f7-list-input>

                <f7-button class="mb-sm mt-xl" large fill @click="submitForm" :disabled="!isNextButtonValid">
                    {{$t('general-btn-submit')}}
                </f7-button>
            </f7-list>
        </div>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import store from '../../store';

    export default {
        props: {
            type: Number,
            data: Object,
        },
        data() {
            return {
                isNextButtonValid   : false,
                password            : "",
                passwordInputType   : "password",
            }
        },
        mounted (){

        },
        methods: {
            ...mapActions('auth', ['login']),
            ...mapActions('otp', ['requestotp']),
            ...mapActions('customer', ['updateCustomerEmail']),

            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            validateInput(e) {
                var regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
                var validate = regex.test(e.value);
                this.isNextButtonValid = validate;
                if(!validate){
                    this.setInputState(e.name, this.$t('placeholder-password'));
                    return false;
                }

                this.setInputState(e.name, true);
                return true;
            },
            async submitForm(e) {
                e.preventDefault();
                if(this.type == 1) {
                    this.showPreloader();
                    try {
                        const result = await this.$api.customer.updateCustomerEmail(this.password, '', this.data.oldEmail, this.data.newEmail);
                        this.hidePreloader();
                        if(result === undefined || result.length <= 0) {
                            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                            return false;
                        }

                        this.$f7router.navigate("/account/email-verify");
                    } catch(e){
                        this.hidePreloader();
                        if(e.message.toLowerCase().includes("undefined")) {
                            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        } else {
                            this.$f7.dialog.alert(e.message);
                        }
                    }
                } else if(this.type == 2) {
                    this.showPreloader();
                    try {
                        var updateData = store.state.misc;
                        updateData.mobileCountryId = this.data.mobileCountryId;
                        updateData.mobileNo = this.data.mobileNo;
                        updateData.newMobileCountryId = this.data.newMobileCountryId;
                        updateData.newMobileNo = this.data.newMobileNo;
                        updateData.password = this.password;
                        updateData.appleToken = "";

                        const result = await this.$api.customer.validateCustomerMobileNumber();
                        if(result.status == 3132) {
                            const result = await this.$api.otp.requestotp(4);
                            this.hidePreloader();
                            if(result.status) {
                                updateData.otp.routerTo = 'editMobilePhone';
                                this.$f7router.navigate("/otp");
                            } else {
                                this.$f7.dialog.alert(result.message);
                            }
                        } else {
                            this.hidePreloader();
                            this.$f7.dialog.alert(result.message);
                            if(result.status == 3133 || result.status == 3139) {
                                this.backButton();
                            }
                        }
                    } catch(e){
                        this.hidePreloader();
                        if(e.message.toLowerCase().includes("undefined")) {
                            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        } else {
                            this.$f7.dialog.alert(e.message);
                        }
                    }
                }
            },
            showHidePassword(){
                let $$ = this.Dom7;
                if(this.passwordInputType == "password"){
                    this.passwordInputType = "text";
                    $$("#password-icon").html('<i class="f7-icons">eye</i>');
                } else {
                    this.passwordInputType = "password";
                    $$("#password-icon").html('<i class="f7-icons">eye_slash</i>');
                }
            },
            backButton() {
                this.$f7router.back({ transition: 'f7-push' });
            }
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ]),
        }
    }
</script>